var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAirplaneTilt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M13.0964 5.02507L10.9932 6.99994L12.9932 12.4999L11.4932 13.9999L8.50517 9.62624L6.99316 10.9999V12.4999L5.49316 13.9999L4.60614 11.3841L1.99316 10.4999L3.49316 8.99994H4.99316L6.49316 7.49994L1.99316 4.49994L3.49316 2.99994L8.99316 4.99994L10.9751 2.90375L10.9325 2.93929C11.0717 2.79975 11.2371 2.68902 11.4192 2.61343C11.6012 2.53785 11.7964 2.49889 11.9935 2.49878C12.1906 2.49867 12.3858 2.53742 12.568 2.6128C12.7501 2.68819 12.9156 2.79873 13.055 2.93812C13.1944 3.07751 13.3049 3.243 13.3803 3.42514C13.4557 3.60727 13.4944 3.80248 13.4943 3.9996C13.4942 4.19673 13.4553 4.39189 13.3797 4.57395C13.3041 4.756 13.1934 4.92137 13.0538 5.0606L13.0964 5.02507Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirplaneTilt);
export default __webpack_public_path__ + "static/media/airplaneTilt.a487493c0a3549f05f973553937a6bbc.svg";
export { ForwardRef as ReactComponent };